export default __webpack_public_path__ + "static/media/success.56917420.svg";